import getters from './getters';
import actions from './actions';
import mutations from './mutations';

const state = {
  list: [],
  detail: {},
  preViewImage: {},
  selectedImage: null,
  hasItem: false,
  galleryItemList: []
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
};
